module.exports = __webpack_public_path__ + "static/media/bin.90e56d32.svg";